export const COMPANY = {
  name: 'F&M Umzüge & Entrümpelung',
  short: 'F&M',
  slogan: 'Wir packen das.',
  tagline: 'Zuverlässig. Sauber. Schnell.',
  email: 'info@fm-umzuege.de',
  website: 'www.fm-umzuege.de',
  street: 'Tucholskystraße 41',
  city: '16761 Henningsdorf',
  hours: 'Mo – Sa: 08:00 – 20:00 Uhr',
};

export const NAV_LINKS = [
  { label: 'Startseite', href: '#start', testid: 'nav-link-home' },
  { label: 'Leistungen', href: '#leistungen', testid: 'nav-link-services' },
  { label: 'Über uns', href: '#ueber-uns', testid: 'nav-link-about' },
  { label: 'Ablauf', href: '#ablauf', testid: 'nav-link-process' },
  { label: 'Kontakt', href: '#kontakt', testid: 'nav-link-contact' },
];

export const SERVICES = [
  {
    id: 'umzuege',
    title: 'Umzüge',
    desc: 'Zuverlässige Unterstützung bei privaten und gewerblichen Umzügen.',
    icon: 'Home',
    image: 'https://images.unsplash.com/photo-1714647211902-bb711d643a17?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
  {
    id: 'moebeltransporte',
    title: 'Möbeltransporte',
    desc: 'Sicherer Transport von Möbeln und größeren Gegenständen.',
    icon: 'Truck',
    image: 'https://images.unsplash.com/photo-1698917414969-feade59e3343?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
  {
    id: 'kleintransporte',
    title: 'Kleintransporte',
    desc: 'Flexible Transportlösungen für kleinere Aufträge.',
    icon: 'Package',
    image: 'https://images.unsplash.com/photo-1600725935160-f67ee4f6084a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
  {
    id: 'entruempelung',
    title: 'Entrümpelung',
    desc: 'Schnelle und gründliche Entrümpelung von Wohnungen, Häusern und Räumen.',
    icon: 'Sparkles',
    image: 'https://images.unsplash.com/photo-1663625318264-695d2d04f11a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
  {
    id: 'sperrmuell',
    title: 'Sperrmüllentsorgung',
    desc: 'Abholung und fachgerechte Entsorgung von Sperrmüll.',
    icon: 'Trash2',
    image: 'https://images.unsplash.com/photo-1586781383963-8e66f88077ec?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
  {
    id: 'haushaltsaufloesungen',
    title: 'Haushaltsauflösungen',
    desc: 'Unterstützung bei vollständigen Haushalts- und Wohnungsauflösungen.',
    icon: 'KeyRound',
    image: 'https://images.unsplash.com/photo-1730154838368-c37b1fdebcf6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
];

export const REASONS = [
  { title: 'Zuverlässig', desc: 'Pünktlich zum vereinbarten Termin – mit festem Ansprechpartner für Ihr Projekt.', icon: 'ShieldCheck' },
  { title: 'Schnell', desc: 'Zügige Bearbeitung Ihrer Anfrage und effiziente Umsetzung vor Ort.', icon: 'Zap' },
  { title: 'Sauber', desc: 'Sorgfältiger Umgang mit Ihrem Eigentum und besenreine Übergabe.', icon: 'CheckCircle2' },
  { title: 'Persönlicher Service', desc: 'Individuelle Beratung – direkt, ehrlich und ohne Umwege.', icon: 'UserCheck' },
  { title: 'Faire & transparente Preise', desc: 'Klare Kostenvoranschläge ohne versteckte Zusatzkosten.', icon: 'BadgePercent' },
  { title: 'Professionelle Abwicklung', desc: 'Erfahrenes Team, modernes Equipment, saubere Organisation.', icon: 'Briefcase' },
];

export const STEPS = [
  { step: '01', title: 'Anfrage senden', desc: 'Formular ausfüllen – wir sind sofort für Sie da.' },
  { step: '02', title: 'Besichtigung / Beratung', desc: 'Wir verschaffen uns ein Bild und beraten Sie persönlich und ehrlich.' },
  { step: '03', title: 'Angebot erhalten', desc: 'Sie erhalten ein transparentes, unverbindliches Angebot zum fairen Preis.' },
  { step: '04', title: 'Professionelle Durchführung', desc: 'Unser Team packt an – termingerecht, sauber und zuverlässig.' },
];

export const MARQUEE_ITEMS = [
  'Umzüge',
  'Möbeltransporte',
  'Entrümpelung',
  'Sperrmüllentsorgung',
  'Kleintransporte',
  'Haushaltsauflösungen',
  'Zuverlässig',
  'Sauber',
  'Schnell',
];

export const TESTIMONIALS = [
  {
    name: 'Familie Schneider',
    meta: 'Privatumzug · Berlin',
    text: 'Von der Anfrage bis zur Übergabe alles reibungslos. Das Team war pünktlich, schnell und sehr sorgfältig mit unseren Möbeln.',
  },
  {
    name: 'M. Krüger',
    meta: 'Haushaltsauflösung · Henningsdorf',
    text: 'Sehr diskrete und gründliche Arbeit. Die Wohnung wurde besenrein übergeben – genau wie besprochen. Klare Empfehlung.',
  },
  {
    name: 'S. Yilmaz',
    meta: 'Entrümpelung · Brandenburg',
    text: 'Faires Festpreisangebot ohne versteckte Kosten. Keller und Garage waren in wenigen Stunden komplett leer.',
  },
];

export const SERVICE_OPTIONS = [
  'Umzug (privat)',
  'Umzug (gewerblich)',
  'Möbeltransport',
  'Kleintransport',
  'Entrümpelung',
  'Sperrmüllentsorgung',
  'Haushaltsauflösung',
  'Sonstiges',
];
